import React, { useState, useEffect } from "react";
import api from "../../services/api";
import { Users } from "lucide-react";

export default function AgentCustomers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getAgentCustomers().then(setCustomers).catch(console.error).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="agent-customers-page">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Assigned Customers</h1>
      <div className="bg-white border border-gray-200 rounded-xl overflow-hidden">
        {loading ? (
          <div className="p-8 text-center text-gray-400">Loading...</div>
        ) : customers.length === 0 ? (
          <div className="p-12 text-center">
            <Users className="w-12 h-12 text-gray-300 mx-auto mb-3" />
            <p className="text-gray-500">No customers assigned yet</p>
            <p className="text-gray-400 text-sm mt-1">Customers will appear here when an admin assigns them to you</p>
          </div>
        ) : (
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-200 bg-gray-50">
                <th className="text-left px-6 py-4 text-xs font-medium text-gray-500 uppercase">Name</th>
                <th className="text-left px-6 py-4 text-xs font-medium text-gray-500 uppercase">Email</th>
                <th className="text-left px-6 py-4 text-xs font-medium text-gray-500 uppercase">Company</th>
                <th className="text-left px-6 py-4 text-xs font-medium text-gray-500 uppercase">Executions</th>
              </tr>
            </thead>
            <tbody>
              {customers.map((c) => (
                <tr key={c.id} data-testid={`customer-row-${c.id}`} className="border-b border-gray-100 hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm text-gray-900">{c.full_name}</td>
                  <td className="px-6 py-4 text-sm text-gray-600">{c.email}</td>
                  <td className="px-6 py-4 text-sm text-gray-600">{c.company_name || "-"}</td>
                  <td className="px-6 py-4 text-sm text-gray-900 font-medium">{c.execution_count || 0}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
